import { siteDevelopmentUrl } from "../../utility/Index";

export const disputeCenterData = {
  DisputeCentre: {
    Title: "Dispute Center",
    GeneralTopData: [
      "Disputes can arise when players disagree on the outcome of a challenge, suspect cheating, or claim rule violations. Here's what to do if a dispute arises:",
    ],
    GeneralBottomData: [""],
    Steps: [
      {
        StepTitle: "When to File a Dispute",
        Description: [
          "Disagreement on Outcome: If both players claim victory.",
          "Cheating: Suspected use of unfair advantages.",
          "Breaking Rules: If an opponent didn’t follow the agreed-upon rules.",
        ],
      },
      {
        StepTitle: "Steps to File a Dispute",
        Description: [
          `Access the <a href='${siteDevelopmentUrl}/DisputeCenter'>Dispute Centre</a>: Navigate to the Help section and select the Dispute Centre.`,
          "Select the Challenge: Choose the challenge in question.",
          "Provide Evidence: Submit screenshots, videos, or stream recordings that support your claim.",
          "Describe the Dispute: Clearly explain the issue (e.g., dishonest claim, rule violation).",
        ],
      },
      {
        StepTitle: "Review Process",
        Description: [
          "Both Players Respond: Both parties provide their side of the story.",
          "Moderation Team Review: The moderation team reviews all submitted evidence.",
          "Resolution Time: Disputes are generally resolved within a set timeframe, depending on complexity.",
        ],
      },
      {
        StepTitle: "Dispute Resolution",
        Description: [
          "Possible Outcomes: The moderation team may award the win to the rightful player, refund wagers, or suggest a rematch.",
          "Final Decision: All decisions made by the Dispute Centre are final.",
        ],
      },
      {
        StepTitle: "Preventing Disputes",
        Description: [
          "Stick to Rules: Always follow the agreed rules for the game.",
          "Provide Proof: Record gameplay or take screenshots of key moments to prevent future disputes.",
        ],
      },
    ],
  },
};
